import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { ObjectAlert } from "../alerts";
import { JoinTextObjectEditor } from "../objectEditors";

export class JoinTextObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof JoinTextObjectEditor) {
      const items = object.textJoinBehavior().getValue().items;
      if (!items || items.length < 1) {
        alerts.push(new ObjectAlert(object, "結合対象項目を設定してください。"));
      }
    }
    return alerts;
  }
}
